import React, {useState} from "react";
import { Table, Grid } from "antd";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

const { useBreakpoint } = Grid;

const ItemLedgerTable = ({ printMode = false }) => {
  const screens = useBreakpoint();
  const { list, loading } = useSelector((state) => state.itemLedger);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const ledger = list?.ledger || [];
  const openingStock = list?.opening_qty_display || "0";
  const closingStock = list?.closing_qty_display || "0";

  const tableData = [
    {
      id: "opening",
      rowType: "opening",
      stock: openingStock,
    },
    ...ledger.map((row, index) => ({
      ...row,
      id: row.id || `ledger-${index}`,
      rowType: "ledger",
    })),
    {
      id: "closing",
      rowType: "closing",
      stock: closingStock,
    },
  ];

  const columns = [
    {
      title: "No.",
      render: (_, record, index) =>
        record.rowType === "ledger" ? index : null,
      width: 60,
    },
    {
      title: "Date",
      dataIndex: "created_date",
      render: (val, record) => {
        if (record.rowType === "opening") {
          return { children: "Opening Stock", props: { colSpan: 6 } };
        }
        if (record.rowType === "closing") {
          return { children: "Closing Stock", props: { colSpan: 6 } };
        }
        return val ? dayjs(val).format("DD-MMM-YYYY") : "";
      },
    },
    {
      title: "Particular",
      dataIndex: "particular",
      render: (_, record) =>
        record.rowType === "opening" || record.rowType === "closing"
          ? { children: null, props: { colSpan: 0 } }
          : _,
    },
    {
      title: "VCH No",
      dataIndex: "vch_no",
      render: (_, record) =>
        record.rowType === "opening" || record.rowType === "closing"
          ? { children: null, props: { colSpan: 0 } }
          : _,
    },
    {
      title: "VCH Type",
      dataIndex: "vch_type",
      render: (_, record) =>
        record.rowType === "opening" || record.rowType === "closing"
          ? { children: null, props: { colSpan: 0 } }
          : _,
    },
    {
      title: "In Quantity",
      dataIndex: "in_qty",
      align: "right",
      render: (_, record) =>
        record.rowType === "opening" || record.rowType === "closing"
          ? { children: null, props: { colSpan: 0 } }
          : _,
    },
    {
      title: "Out Quantity",
      dataIndex: "out_qty",
      align: "right",
      render: (_, record) =>
        record.rowType === "opening" || record.rowType === "closing"
          ? { children: null, props: { colSpan: 0 } }
          : _,
    },
    {
      title: "Current Stock",
      dataIndex: "current_qty",
      align: "right",
      render: (val, record) => {
        if (record.rowType === "opening" || record.rowType === "closing") {
          return <strong>{record.stock}</strong>; // ✅ stock only here
        }
        return val;
      },
    },
  ];

  return (
    <div className={printMode ? undefined : "item-ledger-table-scroll"}>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={tableData}
        loading={loading}
        pagination={printMode ? false : {
        current: currentPage,
        pageSize: pageSize,
        total: tableData.length,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 50, 100],
        onChange: (page) => {
          setCurrentPage(page);
        },
        onShowSizeChange: (_, size) => {
          setPageSize(size);
          setCurrentPage(1);
        },
        }}
        bordered
        size={printMode ? "small" : screens.md ? "middle" : "small"}
        scroll={printMode ? undefined : { x: "max-content" }}
      />
    </div>
  );
};

export default ItemLedgerTable;
